module.exports = __webpack_public_path__ + "img/location-black.afbc4cc3.svg";